import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Private images (wallpapers, family photos) need the bearer token, so we fetch them as blobs.
const cache = new Map();

export function blobUrl(path) {
  if (cache.has(path)) return cache.get(path);
  const p = api.get(path, { responseType: "blob" }).then((r) => URL.createObjectURL(r.data));
  cache.set(path, p);
  p.catch(() => cache.delete(path));
  return p;
}

export function clearBlobCache() {
  cache.forEach((p) => p.then((u) => URL.revokeObjectURL(u)).catch(() => {}));
  cache.clear();
}

export function useAuthedSrc(path) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let live = true;
    setSrc(null);
    if (path) blobUrl(path).then((u) => live && setSrc(u)).catch(() => live && setSrc(null));
    return () => { live = false; };
  }, [path]);
  return src;
}

export const IMAGE_EXT = ["jpg", "jpeg", "png", "webp", "heic", "heif"];
export const MAX_IMAGE_BYTES = 15 * 1024 * 1024;
export const imageOk = (f) => IMAGE_EXT.includes((f.name.split(".").pop() || "").toLowerCase()) && f.size > 0 && f.size <= MAX_IMAGE_BYTES;
